export const list = [
  { id: 1, name: "Upcoming", labelKey: "upcoming", count: 0 },
  { id: 2, name: "Completed", labelKey: "completed", count: 0 },
  { id: 3, name: "Cancelled", labelKey: "cancelled", count: 0 },
  { id: 3, name: "No Shows", labelKey: "noShows", count: 0 },
];

const UpcomingHeaders = [
  { id: 9, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Meeting Link", labelKey: "meetingLink" },
  { id: 8, title: "Client Confirm", labelKey: "clientConfirm"},
  { id: 2, title: "Attendee's Name", labelKey: "attendeesName" },
  { id: 3, title: "Date & Time", labelKey: "dateTime" },
  { id: 5, title: "Session Type", labelKey: "sessionType" },
   { id: 6, title: "Payment Status", labelKey: "paymentStatus" },
  { id: 7, title: "Payment Request", labelKey: "paymentRequest"},
  { id: 8, title: "Session Issue", labelKey: "sessionIssue" },
  { id: 9, title: "Actions", labelKey: "actions" },
];

const CompletedHeaders = [
  { id: 8, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Attendee's Name", labelKey: "attendeesName" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  { id: 3, title: "Session Type", labelKey: "sessionType" },
  { id: 4, title: "Feedback", labelKey: "feedback" },
  { id: 8, title: "Payment Status", labelKey: "paymentStatus" },
  { id: 9, title: "Payment Request", labelKey: "paymentRequest"},
  { id: 6, title: "Session Issue", labelKey: "sessionIssue" },
  { id: 10,title: "No Repeat", labelKey: "noRepeat"},
  { id: 7, title: "Actions", labelKey: "actions" },
];

const CancelledHeaders = [
  { id: 7, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Attendee's Name", labelKey: "attendeesName" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  { id: 4, title: "Session Type", labelKey: "sessionType" },
  { id: 5, title: "Date and Time Cancelled", labelKey: "dateTimeCancelled" },
  { id: 8,title: "No Repeat", labelKey: "noRepeat"},
  { id: 6, title: "Cancelled By", labelKey: "cancelledBy" },
  { id: 7, title: "Reason", labelKey: "reason" },
  { id: 8, title: "Payment Status", labelKey: "paymentStatus" },
   { id: 9, title: "Payment Issue", labelKey: "paymentIssue" },
];

const NoShowsHeaders = [
  { id: 7, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Attendee's Name", labelKey: "attendeesName" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  { id: 4, title: "Session Type", labelKey: "sessionType" },
  { id: 5, title: "Date and Time Cancelled", labelKey: "dateTimeCancelled" },
  { id: 8,title: "No Repeat", labelKey: "noRepeat"},
  // { id: 9,title: "Status"},
  { id: 6, title: "No Show By", labelKey: "noShowBy" },
];

const filterList = [
  {
    id: 1,
    name: "Attendee Name",
    labelKey: "attendeeName",
    value: "screen_name",
  },
  {
    id: 2,
    name: "Session Type",
    labelKey: "sessionType",
    value: "session_type",
  },
  {
    id: 3,
    name: "Appointment Id",
    labelKey: "appointmentId",
    value: "meeting_id",
  },
];
export {
  UpcomingHeaders,
  CompletedHeaders,
  CancelledHeaders,
  NoShowsHeaders,
  filterList,
};
